<template>
<div>
  <ItpButton
    :disabled="!invoice.meta.has_print_document"
    variant="light"
    :icon="printerIcon"
    :href="invoice.links.print_url"
    target="_blank"
    use-auth
    show-spinner
    v-if="isVisible && loaded && noSplit"
  >
  </ItpButton>
  <b-dropdown
    variant="light"
    split
    class="ml-auto mr-2 border"
    v-if="isVisible && loaded && !noSplit"
    @click="evh_6804155476809633_click($event, {})"
  >
    <template
      :title="'Open print document'|pgettext('Invoice')"
      slot="button-content"
    >
      <b-spinner
        spinning
        type="grow"
        class="mr-1"
        v-if="actions.openDocument && actions.openDocument.isRunning"
      >
      </b-spinner>
      <DIV
        :title="'Open print document in a new browser tab.'|pgettext('Invoice')"
        :class="['mr-1', !invoice.meta.has_print_document ? 'text-muted' : null]"
      >
        <ItpIcon
          :name="printerIcon"
        >
        </ItpIcon>
      </DIV>
    </template>
    <b-dropdown-item-button
      v-if="invoice.meta.invoice_view_upload_enabled"
      @click.prevent.stop="evh_5974459770896956_clickPreventStop($event, {})"
    >
      <ItpText
        :text="'Upload print document'|pgettext('Invoice|Command')"
      >
      </ItpText>
    </b-dropdown-item-button>
    <b-dropdown-item-button
      v-if="invoice.meta.has_print_document && invoice.meta.invoice_view_delete_enabled"
      @click.prevent.stop="evh_8852205820859826_clickPreventStop($event, {})"
    >
      <ItpText
        :text="'Delete print document'|pgettext('Invoice|Command')"
      >
      </ItpText>
    </b-dropdown-item-button>
  </b-dropdown>
</div>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcInvoiceViewDocumentDropdown extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  invoice!: object;

  @Watch('invoice')
  onInvoice(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoice")
  }

  icons!: any;
  ux!: any;
  dataMembers = ['icons', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        icons: {
          printerOn: "icon-park-outline:printer-one",
          printerOff: "icon-park-outline:doc-fail",
        }
        ,
        ux: null,
      },
    }
  }

  get isVisible() {
    if (this.loaded) {

      return this.invoice.meta && (
        this.invoice.meta.has_print_document ||
        this.invoice.meta.invoice_view_upload_enabled ||
        this.invoice.meta.invoice_view_delete_enabled
      )
    }
    return null;
  }

  get noSplit() {
    if (this.loaded) {

      return this.invoice.meta &&
        !this.invoice.meta.invoice_view_upload_enabled &&
        !this.invoice.meta.invoice_view_delete_enabled
    }
    return null;
  }

  get printerIcon() {
    if (this.loaded) {

      return this.invoice.meta && this.invoice.meta.has_print_document ? this.icons.printerOn : this.icons.printerOff
    }
    return null;
  }

  async act_6804155476809633_script_7250_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_6804155476809633_script_7250, alias=openDocument
    this.$fn.showFileInNewTab(this.invoice.links.print_url)
  }

  async act_6804155476809633_script_7250_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_6804155476809633_script_7250, alias=openDocument
    return {
      value: () => this.act_6804155476809633_script_7250_getActionArgs_value($event),
    }
  }

  async evh_6804155476809633_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6804155476809633_click.executeFromDOM(this, event, scope);
  }

  async act_5974459770896956_showModal_7252_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_5974459770896956_showModal_7252, alias=undefined
    return {
      name: "FileSelector",
      props: {
        url: this.invoice.links.print_url,
        accept: this.invoice.meta.accepted_print_document_formats,
      }
      ,
    }
  }

  async evh_5974459770896956_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5974459770896956_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_8852205820859826_rest_7254_getActionArgs($event: actions.ActionEvent): Promise<actions.RestActionArgs> {
    // parameterResolver name=act_8852205820859826_rest_7254, alias=undefined
    return {
      method: "delete",
      container: this.container,
      resource: this.invoice,
    }
  }

  async act_8852205820859826_rest_7254_getConfirm($event: actions.ActionEvent): Promise<actions.RestActionArgs> {
    // parameterResolver name=act_8852205820859826_rest_7254, alias=undefined
    return {
      message: this.$fn.gettext("Please confirm delete."),
      btnOk: this.$fn.gettext("Delete"),
    }
  }

  async evh_8852205820859826_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8852205820859826_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_6804155476809633_script_7250: actions.ScriptAction;
    evh_6804155476809633_click_7249: actions.EventHandlerImpl;
    evh_6804155476809633_click: actions.EventHandlerGroup;
    act_5974459770896956_showModal_7252: actions.ShowModalAction;
    evh_5974459770896956_clickPreventStop_7251: actions.EventHandlerImpl;
    evh_5974459770896956_clickPreventStop: actions.EventHandlerGroup;
    act_8852205820859826_rest_7254: actions.RestAction;
    evh_8852205820859826_clickPreventStop_7253: actions.EventHandlerImpl;
    evh_8852205820859826_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_6804155476809633_script_7250 = new actions.ScriptAction(
      {
        actionArgs: this.act_6804155476809633_script_7250_getActionArgs,
        displayName: "openDocument",
        events: [],
      }
    );
    const evh_6804155476809633_click_7249 = new actions.EventHandlerImpl(
      {
        action: act_6804155476809633_script_7250,
        event: "click",
        displayName: "openDocument",
      }
    );
    const evh_6804155476809633_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_6804155476809633_click_7249],
      }
    );
    const act_5974459770896956_showModal_7252 = new actions.ShowModalAction(
      {
        actionArgs: this.act_5974459770896956_showModal_7252_getActionArgs,
        events: [],
      }
    );
    const evh_5974459770896956_clickPreventStop_7251 = new actions.EventHandlerImpl(
      {
        action: act_5974459770896956_showModal_7252,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_5974459770896956_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_5974459770896956_clickPreventStop_7251],
      }
    );
    const act_8852205820859826_rest_7254 = new actions.RestAction(
      {
        actionArgs: this.act_8852205820859826_rest_7254_getActionArgs,
        confirm: this.act_8852205820859826_rest_7254_getConfirm,
        events: [],
      }
    );
    const evh_8852205820859826_clickPreventStop_7253 = new actions.EventHandlerImpl(
      {
        action: act_8852205820859826_rest_7254,
        event: "click.prevent.stop",
        displayName: "rest",
      }
    );
    const evh_8852205820859826_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8852205820859826_clickPreventStop_7253],
      }
    );
    return {
      act_6804155476809633_script_7250,
      evh_6804155476809633_click_7249,
      evh_6804155476809633_click,
      act_5974459770896956_showModal_7252,
      evh_5974459770896956_clickPreventStop_7251,
      evh_5974459770896956_clickPreventStop,
      act_8852205820859826_rest_7254,
      evh_8852205820859826_clickPreventStop_7253,
      evh_8852205820859826_clickPreventStop,
      openDocument: act_6804155476809633_script_7250,
    }
  }
}

Vue.component("UcInvoiceViewDocumentDropdown", UcInvoiceViewDocumentDropdown);

</script>